import Cookies from 'js-cookie';

export const storeExtensions = {
  actions: {
    setCurrentPrinterClientID({ commit }, printerClientID) {
      commit('SET_CURRENT_PRINTER_CLIENT', printerClientID);
    }
  },
  getters: {
    getCurrentPrinterClientID(state) {
      return state.currentPrinterClientID && +state.currentPrinterClientID;
    },
    getCurrentPrinterClientName(state) {
      const id = state.currentPrinterClientID && +state.currentPrinterClientID;
      const item = state.items.find(item => item.id === +id);
      return item && item.name;
    }
  },
  mutations: {
    SET_CURRENT_PRINTER_CLIENT: (state, currentPrinterClientID) => {
      state.currentPrinterClientID = currentPrinterClientID;
      if (currentPrinterClientID >= 0) {
        Cookies.set('currentPrinterClientID', currentPrinterClientID);
      } else {
        Cookies.remove('currentPrinterClientID');
      }
    }
  },
  state: {
    currentPrinterClientID: +Cookies.get('currentPrinterClientID') || ''
  }
};
